import React, { PureComponent } from 'react'
import { Button, Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import {
  checkSession,
  fetchUsersTxFast,
  fetchUserTxById,
  getSpecificPage,
  resetFetchUserTxById,
  updateTxState,
} from '../../actions'
import { validateAddress } from '../../actions/address_validation'
import { fetchAppContextForTx } from '../../actions/app_context'
import { fetchErrors } from '../../actions/error_management'
import { openIdentityInfoModalDialog } from '../../actions/identity_info_modal_dialog'
import { resetModalConfirmation } from '../../actions/modal_confirmation'
import { fetchRelatedTransactions, resetFetchRelatedTransactions } from '../../actions/related_transactions'
import { resetSearchPhoneNumberTransactions, searchPhoneNumberTransactions } from '../../actions/search_phone_number'
import {
  resetSearchDocumentNumberTransactions,
  searchDocumentNumberTransactions,
} from '../../actions/search_document_number'
import { openProcessTransactionStartModalDialog } from '../../actions/start_process_transaction'
import Addresses from '../../components/common/addresses'
import DataListings from '../../components/common/data_listings/data_listings'
import DataSources from '../../components/common/data_sources'
import ErrorMessageTable from '../../components/common/error_message_table'
import MediaReferences from '../../components/common/media_references'
import RoundCornerIBox from '../../components/common/round_corner_ibox'
import { ButtonBackDiv, DivContentBox } from '../../components/common/styled'
import TransactionNotesTable from '../../components/common/transaction_notes'
import Spinner3Bounce from '../../components/spinner_3_bounce'
import AccessCodeLineage from '../../components/tx_details_components/access_code_lineage'
import BusinessName from '../../components/tx_details_components/business_name'
import ClientGuid from '../../components/tx_details_components/client_guid'
import FaceMatchScore from '../../components/tx_details_components/face_match_score'
import IdDisplay from '../../components/tx_details_components/id_display'
import IdDocuments from '../../components/tx_details_components/id_documents'
import IdEmails from '../../components/tx_details_components/id_emails'
import IdPhase from '../../components/tx_details_components/id_phase'
import IdPhoneNumbers from '../../components/tx_details_components/id_phone_numbers'
import IdPhotos from '../../components/tx_details_components/id_photos'
import IdStatus from '../../components/tx_details_components/id_status'
import IdentityInfoModalDialog from '../../components/tx_details_components/identity_info_modal_dialog'
import ProcessTransactionStartModalDialog from '../../components/tx_details_components/process_transaction_start_modal_dialog'
import RelatedTransactions from '../../components/tx_details_components/related_transactions'
import TransactionMetadata from '../../components/tx_details_components/transaction_metadata/transaction_metadata'
import TxAuditLog from '../../components/tx_details_components/tx_audit_log'
import TxBusinessInfo from '../../components/tx_details_components/tx_business_info'
import TxCallbacks from '../../components/tx_details_components/tx_callbacks'
import TXDetailsAccreditedStatus from '../../components/tx_details_components/tx_details_accredited_status'
import TxDetailsButtons from '../../components/tx_details_components/tx_details_buttons'
import TxIdentityInfo from '../../components/tx_details_components/tx_identity_info'
import { __isEnvDev, APP_LAST_VISITED_USER_TX_URL, STORAGE_TYPE_LOCAL } from '../../config'
import StorageProviderFactory from '../../managers/storage_provider_factory'
import { APP_FF } from '../../middleware/api'
import SortData from '../../models/sort_data'
import { fi, filterIdentityDataSources } from '../../utils/filters'
import { isClientReviewer, isStaff, isIdentityUsingMinerva } from '../../utils/helpers'
import { addToSearch, getSearchParams, getStatusFilter, isNewWindow } from '../../utils/helpers'
import { searchBarOptions } from '../../components/transaction_grid/search_bar'
import './txDetails.scss'
import AMLSources from '../../components/common/aml_sources/aml_sources'
import AMLNonSanctionSources from '../../components/common/aml_sources/aml_non_sanction_sources'

const HideShowDetailsBox = styled.div`
  text-align: center;
  margin-bottom: 20px;
`

export class TxDetails extends PureComponent {
  constructor(props) {
    super(props)
    const params = getSearchParams()
    this.state = {
      width: window.innerWidth,
      showMoreDetails: false,
      ii: false,
      aeb: false,
      tm: false,
      sanctionListComplianceCount: 0,
      sanctionListMediaCount: 0,
      investorAccreditationCount: 0,
      filter: params,
      prevId: null,
      nextId: null,
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentDidMount() {
    this.init()
  }

  async init() {
    this.props.checkSession()
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
    const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)
    const ffObj = storageProvider.getItem(APP_FF)
    try {
      if (ffObj && JSON.parse(ffObj)) {
        Object.keys(JSON.parse(ffObj)).forEach((key) => this.setState({ [key]: fi(parseInt(ffObj[key], 16)) }))
      }
    } catch (e) {
      if (__isEnvDev()) {
        console.log('Error encountered: ', e.toString())
      }
    }
    const {
      id,
      fetchUserTxById,
      resetFetchUserTxById,
      resetModalConfirmation,
      fetchErrors,
      fetchAppContextForTx,
      searchPhoneNumberTransactions,
      resetSearchPhoneNumberTransactions,
      searchDocumentNumberTransactions,
      resetSearchDocumentNumberTransactions,
    } = this.props

    this.setState({
      prevId: null,
      nextId: null,
    })
    fetchErrors()
    resetModalConfirmation()
    resetFetchUserTxById()

    await fetchUserTxById(id)
    fetchAppContextForTx(id)
    if (this.props.userTx && this.props.userTx.transaction_identity) {
      const phoneNumbers = this.props.userTx.transaction_identity.identity_phone_numbers.map((i) => i.phone_number)
      resetSearchPhoneNumberTransactions()
      if (phoneNumbers.length) {
        searchPhoneNumberTransactions(phoneNumbers[0])
      }
    }
    if (this.props.userTx && this.props.userTx.transaction_identity) {
      const ti = this.props.userTx.transaction_identity

      const passportNumber = ti.passport_number || null
      const driversLicense = ti.drivers_license || null
      const residentNumber = ti.resident_number || null

      // Reset and search counts for each present document number independently
      resetSearchDocumentNumberTransactions()
      if (passportNumber) {
        searchDocumentNumberTransactions(passportNumber)
      }
      if (driversLicense) {
        searchDocumentNumberTransactions(driversLicense)
      }
      if (residentNumber) {
        searchDocumentNumberTransactions(residentNumber)
      }
    }

    storageProvider.setItem(APP_LAST_VISITED_USER_TX_URL, window.location.pathname)

    await this.setUpPagination()
  }

  setUpPagination = async () => {
    const { filter } = this.state
    const { fetchUsersTxFast, sortField, sortOrder, getSpecificPage, userTxs } = this.props
    let prevId = undefined
    let nextId = undefined
    let currentTxIndex

    if (userTxs && userTxs.length) {
      currentTxIndex = userTxs.findIndex((i) => i.id === this.props.id)
      if (currentTxIndex !== -1) {
        if (currentTxIndex !== 0 && userTxs[currentTxIndex - 1]) {
          prevId = userTxs[currentTxIndex - 1].id
        }
        if (currentTxIndex !== userTxs.length - 1 && userTxs[currentTxIndex + 1]) {
          nextId = userTxs[currentTxIndex + 1].id
        }
      }
    }
    if (prevId === undefined || nextId === undefined) {
      if (filter.index === undefined) return
      let statusFilter = getStatusFilter(filter.filter)
      const { response } = await fetchUsersTxFast(
        filter.page || 1,
        statusFilter.length > 0 && statusFilter[0] ? statusFilter : null,
        filter.search,
        new SortData(sortField, sortOrder),
        filter.business,
        filter.country,
        filter.index,
        filter.created_on,
        filter.page_size
      )
      if (response) {
        const promises = []
        promises.push(
          prevId === undefined && response.previous ? getSpecificPage(response.previous, 'previous') : Promise.resolve()
        )
        promises.push(
          nextId === undefined && response.next ? getSpecificPage(response.next, 'next') : Promise.resolve()
        )
        const [prevData, nextData] = await Promise.all(promises)

        if (prevData && prevData.response && prevData.response.results) {
          prevId = prevData.response.results[0].id
        }
        if (nextData && nextData.response && nextData.response.results) {
          nextId = nextData.response.results[0].id
        }
      }
    }
    this.setState({
      prevId,
      nextId,
    })
  }

  getMissingUserInfo = () => {
    const { userTx } = this.props
    const userData = {
      first_name: userTx.transaction_identity['first_name'],
      last_name: userTx.transaction_identity['last_name'],
      drivers_license: userTx.transaction_identity['drivers_license'],
      passport_number: userTx.transaction_identity['passport_number'],
    }

    return Object.keys(userData).reduce((acc, value, index, arr) => {
      if (!userData[value]) {
        acc.push(value)
      }
      if (arr.length - 1 === index) {
        const dlIncluded = acc.includes('drivers_license') && !acc.includes('passport_number')
        const passIncluded = !acc.includes('drivers_license') && acc.includes('passport_number')
        if (dlIncluded || passIncluded) {
          if (acc.length === 1) {
            return []
          }
          if (acc.includes('drivers_license')) {
            acc.slice(acc.indexOf('drivers_license'), 1)
          }
          if (acc.includes('passport_number')) {
            acc.slice(acc.indexOf('passport_number'), 1)
          }
        }
        return acc
      }
      return acc
    }, [])
  }

  updateComplianceCount = (c) => this.setState({ sanctionListComplianceCount: c })

  updateMediaCount = (c) => this.setState({ sanctionListMediaCount: c })

  updateInvestorAccreditationCount = (c) => this.setState({ investorAccreditationCount: c })

  // checks window width, removes columns if width is too small so it's mobile responsive
  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  toggleMoreDetails = () => {
    this.setState({ showMoreDetails: !this.state.showMoreDetails })
  }

  attemptApprove = (next) => {
    const {
      state: { sanctionListComplianceCount, sanctionListMediaCount, investorAccreditationCount },
    } = this
    if (this.detectMissingDataFields()) {
      if (!sanctionListComplianceCount && !sanctionListMediaCount && !investorAccreditationCount) {
        next()
      } else {
        window.alert(
          "Possible AML/Sanction Hits!  You must review each item in ‘Compliance: Possible Matches’ & ‘Media References' to verify your user is NOT on any AML (anti money laundering) lists. Review each hit & confirm it is not a match, then:" +
            "\n1. Click the checkbox under “Reviewed by Compliance” next to each hit (confirming not a match) & click ‘Approve'." +
            '\n2. Enter internal notes (to prove to government institutions that you did indeed check) & click ‘Save Changes’.'
        )
      }
    }
  }

  detectMissingDataFields = () => {
    const data = this.props.userTx.transaction_identity
    if ((data.first_name === null || data.first_name === '') && (data.last_name === null || data.last_name === '')) {
      this.alertMessage()
      return false
    }
    return true
  }

  alertMessage = () => {
    window.alert(`If both first name and last name fields are empty you may not approve this record.`)
  }

  nextTransactionBtn = () => {
    const params = getSearchParams()

    let search = ''
    if (params.page) {
      search = addToSearch(search, `page=${params.page}`)
    }
    if (params.country) {
      search = addToSearch(search, `country=${params.country}`)
    }
    if (params.search) {
      search = addToSearch(search, `search=${params.search}`)
    }
    if (params.business) {
      search = addToSearch(search, `business=${params.business}`)
    }
    if (params.filter) {
      search = addToSearch(search, `filter=${params.filter}`)
    }
    if (params.created_on) {
      search = addToSearch(search, `created_on=${params.created_on}`)
    }

    const searchParameterArray = Object.keys(params).filter((value) =>
      searchBarOptions.map((i) => i.name).includes(value)
    )
    if (searchParameterArray.length) {
      search = addToSearch(search, `${searchParameterArray[0]}=${params[searchParameterArray[0]]}`)
    }
    return (
      <>
        {this.state.nextId && (
          <Button
            style={{ float: 'right', width: '148px', display: 'block', marginBottom: '15px' }}
            bsPrefix='btn btn-w-m btn-default shadow'
            onClick={(event) => {
              if (params.index) {
                search = addToSearch(search, `index=${parseInt(params.index, 10) + 1}`)
              }
              if (params.page_size) {
                search = addToSearch(search, `page_size=${params.page_size}`)
              }
              const paramsNew = getSearchParams(search)
              this.setState({ filter: paramsNew })
              this.props.viewTx(this.state.nextId + '/' + search, isNewWindow(event))
              if (!isNewWindow(event)) {
                setTimeout(() => this.init(), 100)
              }
            }}
          >
            Next transaction <i className='fa fa-arrow-right' />
          </Button>
        )}

        {this.state.prevId && (
          <Button
            style={{
              float: 'right',
              width: '168px',
              display: 'block',
              marginBottom: '15px',
              marginRight: '10px',
            }}
            bsPrefix='btn btn-w-m btn-default shadow'
            onClick={(event) => {
              if (params.index) {
                search = addToSearch(search, `index=${parseInt(params.index, 10) - 1}`)
              }
              if (params.page_size) {
                search = addToSearch(search, `page_size=${params.page_size}`)
              }
              const paramsNew = getSearchParams(search)
              this.setState({ filter: paramsNew })
              this.props.viewTx(this.state.prevId + '/' + search, isNewWindow(event))
              if (!isNewWindow(event)) {
                setTimeout(() => this.init(), 100)
              }
            }}
          >
            <i className='fa fa-arrow-left' /> Previous transaction
          </Button>
        )}
      </>
    )
  }

  isUnderReview = () => this.props.userTx.state === 'post_processing'

  isUnderCustomerReview = () => this.props.userTx.state === 'customer_review'

  render() {
    const { state, props } = this
    const {
      errorMessage,
      userTx,
      isAuthenticated,
      openProcessTransactionStartModalDialog,
      openIdentityInfoModalDialog,
      appContext,
      updateTxState,
      fetchUserTxById,
      phoneCount,
      documentNumberCounts,
    } = props
    if (!isAuthenticated) {
      return null
    }
    if (errorMessage) {
      return (
        <div className='alert alert-danger animated fadeIn m-t-md'>
          <strong>Error</strong>: {errorMessage}
        </div>
      )
    }

    if (userTx === null) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    if (
      (!isStaff(this.props.user) && this.isUnderReview()) ||
      (!isClientReviewer(this.props.user) && !isStaff(this.props.user) && this.isUnderCustomerReview())
    ) {
      return (
        <div className='alert alert-danger animated fadeIn m-t-md'>
          <strong>Error</strong>: This record is under review. You do not have permission to edit it.
        </div>
      )
    }

    const isRestartEnabled =
      userTx.transaction_identity &&
      userTx.transaction_identity.identity_phone_numbers &&
      userTx.transaction_identity.identity_phone_numbers.length > 0

    let errors = ErrorMessageTable.getErrors(userTx)
    let accreditedInvestorData = []
    if (
      userTx.transaction_identity &&
      userTx.transaction_identity.identity_accredited_investor_status &&
      typeof userTx.transaction_identity.identity_accredited_investor_status === 'object'
    ) {
      if (
        userTx.transaction_identity &&
        userTx.transaction_identity.identity_accredited_investor_status.hasOwnProperty(
          'identity_document_accreditation_status'
        )
      ) {
        if (
          userTx.transaction_identity.identity_accredited_investor_status.identity_document_accreditation_status.length
        ) {
          accreditedInvestorData =
            userTx.transaction_identity.identity_accredited_investor_status.identity_document_accreditation_status.filter(
              (i) => i.document
            )
        }
      }
    }

    // Compute document-number duplicate counters to pass into IdDisplay
    let passportDocCount = 0
    let govIdDocCount = 0
    if (userTx && userTx.transaction_identity) {
      const idData = userTx.transaction_identity
      const dCounts = documentNumberCounts || {}
      if (idData.passport_number) {
        passportDocCount = dCounts[idData.passport_number] || 0
      }
      const govCandidates = []
      if (idData.drivers_license) {
        govCandidates.push(dCounts[idData.drivers_license] || 0)
      }
      if (idData.resident_number) {
        govCandidates.push(dCounts[idData.resident_number] || 0)
      }
      if (govCandidates.length) {
        govIdDocCount = Math.max(...govCandidates)
      }
    }

    return (
      <div className='animated fadeIn'>
        <ButtonBackDiv>
          <Button
            bsPrefix='btn btn-w-m btn-default shadow'
            onClick={(event) => {
              if (window.location.search === '') {
                props.goToList(isNewWindow(event))
              } else {
                props.goToListWithFilters(isNewWindow(event))
              }
            }}
          >
            <i className='fa fa-arrow-left' /> Back
          </Button>
          {this.nextTransactionBtn()}
        </ButtonBackDiv>
        {userTx.transaction_identity && (
          <div>
            {state.width > 810 ? (
              <div className={'row'}>
                <div className='col col-sm-9'>
                  <IdDisplay
                    updateTxState={updateTxState}
                    fetchUserTxById={fetchUserTxById}
                    openProcessTransactionStartModalDialog={openProcessTransactionStartModalDialog}
                    openIdentityInfoModalDialog={openIdentityInfoModalDialog}
                    id={userTx.id}
                    mainData={userTx}
                    data={userTx.transaction_identity}
                    phoneCount={phoneCount}
                    govIdDocCount={govIdDocCount}
                    passportDocCount={passportDocCount}
                  />
                </div>
                <div className='col col-sm-3 section-shadow round-corner-box status-column'>
                  <div className='row'>
                    <ClientGuid
                      business={userTx.transaction_identity.business}
                      data={userTx.transaction_identity.client_guid}
                    />
                  </div>

                  {isStaff(this.props.user) && userTx.client && (
                    <div className='row'>
                      <BusinessName businessId={userTx.client} />
                    </div>
                  )}

                  <div className='row'>
                    <IdStatus currentState={userTx.state} holdReason={userTx.hold_reason} />
                  </div>
                  <div className='row'>
                    <IdPhase currentPhase={userTx.phase} />
                  </div>
                  <DivContentBox className='row'>
                    <FaceMatchScore data={userTx.transaction_identity.identity_data_sources} />
                  </DivContentBox>
                </div>
              </div>
            ) : (
              <div>
                <div>
                  <IdDisplay
                    phoneCount={phoneCount}
                    updateTxState={updateTxState}
                    fetchUserTxById={fetchUserTxById}
                    openProcessTransactionStartModalDialog={openProcessTransactionStartModalDialog}
                    openIdentityInfoModalDialog={openIdentityInfoModalDialog}
                    id={userTx.id}
                    mainData={userTx}
                    data={userTx.transaction_identity}
                    govIdDocCount={govIdDocCount}
                    passportDocCount={passportDocCount}
                  />
                </div>
                <div className='section-shadow round-corner-box'>
                  <div className='row'>
                    <ClientGuid data={userTx.transaction_identity.client_guid} />
                  </div>
                  <div className='row'>
                    <IdStatus currentState={userTx.state} holdReason={userTx.hold_reason} />
                  </div>
                  <DivContentBox className='row'>
                    <FaceMatchScore data={userTx.transaction_identity.identity_data_sources} />
                  </DivContentBox>
                </div>
              </div>
            )}
            <IdentityInfoModalDialog identityData={userTx.transaction_identity} currentPhase={userTx.phase} />
            <ProcessTransactionStartModalDialog txId={userTx.id} />
            <ErrorMessageTable errors={errors} />
            <AccessCodeLineage lineageData={userTx.transaction_identity.identity_access_code} />
            <IdPhotos
              aeb={state.aeb}
              errors={props.errors}
              data={userTx.transaction_identity.identity_documents}
              accreditedInvestorData={accreditedInvestorData}
              identity={userTx.transaction_identity.id}
              updateInvestorAccreditationCount={this.updateInvestorAccreditationCount}
            />
            {userTx.transaction_identity.medical_license && (
              <RoundCornerIBox title='Medical Professional Information'>
                <div className='ibox float-e-margins animated fadeIn'>
                  <Table striped bordered hover>
                    <tbody>
                      <tr>
                        <th>Medical ID</th>
                        <td>{userTx.transaction_identity.medical_license}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </RoundCornerIBox>
            )}
            <TxDetailsButtons
              getMissingUserInfo={this.getMissingUserInfo}
              errors={props.errors}
              attemptApprove={this.attemptApprove}
              id={userTx.id}
              currentState={userTx.state}
              isRestartEnabled={isRestartEnabled}
            />
            {userTx.transaction_identity.is_accredited_investor && (
              <TXDetailsAccreditedStatus identity={userTx.transaction_identity} />
            )}
            {!isIdentityUsingMinerva(userTx.transaction_identity) ? (
              <>
                {/*this section is for Comply Advantage results for clients with their own API keys and legacy Netki Results*/}
                <DataListings
                  id={userTx.id}
                  count={state.sanctionListComplianceCount}
                  updateComplianceCount={this.updateComplianceCount}
                  data={userTx.transaction_identity.identity_data_listings}
                  hitsData={userTx.transaction_identity.identity_data_sources}
                  identityDataSources={userTx.transaction_identity.identity_data_sources}
                  mediaData={userTx.transaction_identity.identity_media_references}
                  type={'identity'}
                />
                <MediaReferences
                  id={userTx.id}
                  count={state.sanctionListMediaCount}
                  updateMediaCount={this.updateMediaCount}
                  hitsData={filterIdentityDataSources(userTx.transaction_identity.identity_data_sources)([
                    parseInt(process.env.REACT_APP_COMPLY_ID),
                    parseInt(process.env.REACT_APP_MINERVA_ID),
                  ])}
                  data={userTx.transaction_identity.identity_media_references}
                />
              </>
            ) : (
              <>
                {/*this section display Minerva results broken out by the sourceTypes (either Sanctions or PEP and News)*/}
                <AMLSources
                  id={userTx.id}
                  count={state.sanctionListComplianceCount}
                  updateComplianceCount={this.updateComplianceCount}
                  identityDataSources={userTx.transaction_identity.identity_data_sources}
                  type={'identity'}
                  sourceTypes={['Sanctions']}
                />
                <AMLNonSanctionSources
                  id={userTx.id}
                  count={state.sanctionListComplianceCount}
                  updateMediaCount={this.updateMediaCount}
                  identityDataSources={userTx.transaction_identity.identity_data_sources}
                  type={'identity'}
                  sourceTypes={['PEP', 'News']}
                />
              </>
            )}

            {state.tm ? <TransactionMetadata metadata={userTx.transaction_metadata} /> : null}
            <RoundCornerIBox title='Notes'>
              {userTx.transaction_notes && userTx.transaction_notes.length > 0 ? (
                <TransactionNotesTable data={userTx.transaction_notes} />
              ) : (
                <span>{'N/A'}</span>
              )}
            </RoundCornerIBox>
            <RelatedTransactions relatedTransactions={props.relatedTransactions} />
            {state.showMoreDetails ? (
              <div>
                {state.ii ? (
                  <TxIdentityInfo appContext={appContext} mainData={userTx} data={userTx.transaction_identity} />
                ) : null}
                <TxBusinessInfo data={userTx.transaction_identity} />
                <IdPhoneNumbers data={userTx.transaction_identity.identity_phone_numbers} />
                <IdEmails data={userTx.transaction_identity.identity_emails} />
                <Addresses
                  data={userTx.transaction_identity.identity_addresses}
                  onValidateClick={false} // props.validateAddress
                  userTx={userTx}
                />
                <IdDocuments data={userTx.transaction_identity.identity_documents} />
                <DataSources data={userTx.transaction_identity.identity_data_sources} />
                <TxCallbacks data={userTx.transaction_callbacks} txId={userTx.id} />
                <TxAuditLog data={userTx.transaction_metadata ? userTx.transaction_metadata.audit_logs : []} />
                <HideShowDetailsBox className='text-center'>
                  <Button className='shadow' onClick={() => this.toggleMoreDetails()}>
                    <i className='fa fa-long-arrow-up' /> Hide Additional Details
                  </Button>
                </HideShowDetailsBox>
                <TxDetailsButtons
                  getMissingUserInfo={this.getMissingUserInfo}
                  errors={props.errors}
                  attemptApprove={this.attemptApprove}
                  id={userTx.id}
                  currentState={userTx.state}
                  isRestartEnabled={isRestartEnabled}
                />
              </div>
            ) : (
              <HideShowDetailsBox className='text-center'>
                <Button className='shadow' onClick={() => this.toggleMoreDetails()}>
                  <i className='fa fa-long-arrow-down' /> See Additional Details
                </Button>
              </HideShowDetailsBox>
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  appContext: state.appContext,
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.txById.errorMessage,
  userTx: state.txById.userTx,
  isFetching: state.txById.isFetching,
  id: ownProps.match.params.id,
  errors: state.errorManagement.errors,
  isRelatedTransactionsFetching: state.fetchRelatedTransactions.isFetching,
  relatedTransactions: state.fetchRelatedTransactions.results,
  sortField: state.txGridSort.sortField,
  sortOrder: state.txGridSort.order,
  userTxs: state.tx.userTxs,
  phoneCount: state.searchPhoneNumberTransactions.count,
  documentNumberCounts: state.searchDocumentNumberTransactions.countsByDocumentNumber,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      checkSession,
      fetchUserTxById,
      resetModalConfirmation,
      resetFetchUserTxById,
      fetchErrors,
      openIdentityInfoModalDialog,
      openProcessTransactionStartModalDialog,
      updateTxState,
      fetchRelatedTransactions,
      resetFetchRelatedTransactions,
      fetchAppContextForTx,
      validateAddress,
      viewTx: (url, metaKey) => {
        if (metaKey) {
          window.open(`/tx-details/${url}`, '_blank')
        } else {
          ownProps.history.push(`/tx-details/${url}`)
        }
      },
      goToList(metaKey) {
        if (metaKey) {
          window.open(`/`, '_blank')
        } else {
          ownProps.history.push('/')
        }
      },
      goToListWithFilters(metaKey) {
        if (metaKey) {
          window.open(`/${window.location.search}`, '_blank')
        } else {
          ownProps.history.push(`/${window.location.search}`)
        }
      },
      fetchUsersTxFast,
      getSpecificPage,
      searchPhoneNumberTransactions,
      resetSearchPhoneNumberTransactions,
      searchDocumentNumberTransactions,
      resetSearchDocumentNumberTransactions,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxDetails))
